import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Fragment, KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";
import "./css/productLine.scss";
import { PortIn } from "./PortIn";
import { ICartOffer } from "./ICart";
import { IPortinForm } from "@common/portIn/IPortinForm";

interface IParams {
    isPortOpen: boolean;
    userOffer: ICartOffer;
    addPortin(cartOfferId: number, portinForm: IPortinForm, closePortInForm?: () => void): void;
    deleteOffer(offerId: number): void;
    deletePortin(offerId: number): void;
    setIsPortOpen(isPortOpen: boolean): void;
}

export const ProductLine = (props: IParams) => {
    const { userOffer, deleteOffer, isPortOpen, setIsPortOpen, deletePortin, addPortin } = props;
    const isPortInOpen = userOffer.port && !isPortOpen;
    const phoneNumberToPort = userOffer.port ? userOffer.port.msisdn : "";
    const toggleIsSwitched = Boolean(userOffer.port) || isPortOpen;
    const { t } = useTranslation("cart");

    const togglePortInForm = () => {
        if (userOffer.port) {
            deletePortin(userOffer.offerId);
            if (isPortOpen) {
                setIsPortOpen(!isPortOpen);
            }
        } else {
            setIsPortOpen(!isPortOpen);
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLLabelElement>) => {
        if (event.key === "Enter" || event.keyCode === 32) {
            togglePortInForm();
        }
    };

    return (
        <div className="xtest_product_lines">
            <Card elevation={2}>
                <CardContent className="productLine">
                    <Grid container justify="space-between">
                        <Grid className="productLine__label" item sm={10} xs={6}>
                            <Typography color="inherit" gutterBottom variant="h3">
                                {userOffer.baseOffer.description}
                            </Typography>
                        </Grid>
                        <Grid className="productLine__label" item sm={2} xs={5}>
                            <Grid alignItems="center" container justify="flex-end">
                                {isPortInOpen && (
                                    <Fragment>
                                        <IconButton
                                            aria-label="Edit"
                                            className="xtest_edit_button"
                                            color="inherit"
                                            onClick={() => setIsPortOpen(true)}
                                        >
                                            <VisibilityIcon />
                                        </IconButton>
                                        <hr className="productLine-actions__separator" />
                                    </Fragment>
                                )}
                                <IconButton
                                    aria-label="Delete"
                                    className="xtest_delete_button"
                                    color="inherit"
                                    data-testid="delete-offer-icon"
                                    onClick={() => deleteOffer(userOffer.offerId)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid alignItems="center" className="productLine-switch" container>
                        <Grid className="productLine__label productLine-switch__label" item>
                            <Typography
                                color="inherit"
                                gutterBottom
                                id={`label-${userOffer.offerId.toString()}`}
                                variant="body1"
                            >
                                {t("keepNumber")}
                            </Typography>
                        </Grid>
                        <Grid className="productLine__label" item>
                            <div className="checkbox">
                                <input
                                    aria-labelledby={`label-${userOffer.offerId.toString()}`}
                                    checked={toggleIsSwitched}
                                    className="xtest_switch_button"
                                    data-testid="toggle-portin-button"
                                    id={userOffer.offerId.toString()}
                                    type="checkbox"
                                    onChange={togglePortInForm}
                                    disabled={userOffer.port ? true : false}
                                />
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/no-noninteractive-tabindex,jsx-a11y/no-noninteractive-element-interactions */}
                                <label htmlFor={userOffer.offerId.toString()} tabIndex={0} onKeyDown={handleKeyDown} />
                            </div>
                        </Grid>
                    </Grid>
                    {isPortInOpen && (
                        <Grid className="productLine-move__info" container>
                            <Grid className="productLine__label" item sm={4} xs={12}>
                                <Typography color="inherit" variant="body1">
                                    {t("phoneNumber")}: {phoneNumberToPort}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                </CardContent>
                {isPortOpen && (
                    <PortIn addPortin={addPortin} closePortInForm={() => setIsPortOpen(false)} offer={userOffer} />
                )}
            </Card>
        </div>
    );
};
